import React from "react";
import { StyledSideBar } from "./styles";

export const HubSideBar = ({ children, ...rest }) => {
  return <StyledSideBar {...rest}>{children}</StyledSideBar>;
};

export default HubSideBar;
